function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "iconcamera");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff8d10",
  d: "M37.829 8.035v20.48c0 1.884-1.539 3.413-3.435 3.413h-29.767c-1.896 0-3.435-1.529-3.435-3.413v-20.48c0-1.884 1.538-3.413 3.435-3.413h6.297l0.88-2.34c0.501-1.33 1.782-2.212 3.213-2.212h8.98c1.431 0 2.712 0.882 3.213 2.212l0.887 2.34h6.297c1.896 0 3.435 1.529 3.435 3.413zM28.098 18.275c0-4.708-3.85-8.533-8.587-8.533s-8.587 3.826-8.587 8.533c0 4.707 3.85 8.533 8.587 8.533s8.587-3.826 8.587-8.533zM25.808 18.275c0 3.449-2.827 6.258-6.297 6.258s-6.297-2.809-6.297-6.258c0-3.449 2.826-6.258 6.297-6.258s6.297 2.809 6.297 6.258z"
});

const SvgIconcamera = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 39,
  height: 32,
  viewBox: "0 0 39 32",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconcamera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconcamera.345c6393.svg";
export { ForwardRef as ReactComponent };